import { render, staticRenderFns } from "./KeywordInput.vue?vue&type=template&id=155b1630&scoped=true"
import script from "./KeywordInput.vue?vue&type=script&lang=js"
export * from "./KeywordInput.vue?vue&type=script&lang=js"
import style0 from "./KeywordInput.vue?vue&type=style&index=0&id=155b1630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b1630",
  null
  
)

export default component.exports